module.exports = __webpack_public_path__ + "media/images/bond_application-4e6c25cb91d023b788adcf8bcc931f46.jpg";